'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rcUtil = require('rc-util');

var _rcUtil2 = _interopRequireDefault(_rcUtil);

var Marks = function Marks(_ref) {
  var className = _ref.className;
  var marks = _ref.marks;
  var index = _ref.index;
  var included = _ref.included;

  var marksLen = marks.length;
  var unit = 100 / (marksLen - 1);
  var markWidth = unit / 2 + '%';

  var elements = [];
  for (var i = 0; i < marksLen; i++) {
    var _rcUtil$classSet;

    var isActived = included && i <= index || !included && i === index;
    var markClassName = _rcUtil2['default'].classSet((_rcUtil$classSet = {}, _defineProperty(_rcUtil$classSet, className + '-text', true), _defineProperty(_rcUtil$classSet, className + '-text-active', isActived), _rcUtil$classSet));

    var style = { width: markWidth };
    var offset = unit * i;
    if (i === marksLen - 1) {
      style.right = -unit / 4 + '%';
    } else {
      style.left = (i > 0 ? offset - unit / 4 : -unit / 4) + '%';
    }

    elements.push(_react2['default'].createElement(
      'span',
      { className: markClassName, style: style, key: i },
      marks[i]
    ));
  }

  return _react2['default'].createElement(
    'div',
    { className: className },
    elements
  );
};

exports['default'] = Marks;
module.exports = exports['default'];